/*
	This form is for Flashtalking Facebook connections.  For Mediaocean Facebook connections, see FacebookVideoMO
*/

import React from "react";
import { FormSection } from "redux-form";

import { SOCIAL_AD_TYPES } from "utils/constants";
import PACController from "social/PACController";

const adType = SOCIAL_AD_TYPES.FACEBOOK_VIDEO;

export default function FacebookVideo(props){
	return (
		<FormSection name={adType}>
			<PACController
				adType={adType}
				{...props}
			/>
		</FormSection>
	);
}

FacebookVideo.displayName = "FacebookVideoForm";
